var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d;
import { Notifier } from "@/common/utils/notifier";
import { ApiRequestModel, GetInitialSnapshotDataQuery, GetSystemSnapshotDataQuery, GetDateSnapshotDataQuery, GetLatestStringSnapshotStatusQuery, GetStringSnapshotsGroupedByTimestampQuery, RequestControllerDataCommand, RequestControllerDataRequestModel, ApiRequestsClient, StringSnapshotClient, SnapshotsClient, SystemCommunicationsClient, MarkApiRequestAsReadCommand, SystemAccessQueryModel } from "@/app/api/battery-portal-api";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import QueryStringHelper from "@/app/utils/querystring-helper";
import RouteNames from "@/app/router/routes";
import moment from "moment";
const snapshotClient = new StringSnapshotClient(window.apiUrl);
const snapshotsClient = new SnapshotsClient(window.apiUrl);
const systemCommunicationsClient = new SystemCommunicationsClient(window.apiUrl);
const apiRequestClient = new ApiRequestsClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
let SnapshotGraphFilterVue = class SnapshotGraphFilterVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.lastSnapshotLoaded = false;
        this.reactToQueryChanges = false;
        this.hasNewSnapshot = false;
        this.snapshotId = new Date();
        this.previousSystemId = null;
        this.selectLastSnapshot = false;
        // Watcher control flags
        this.ignoreSystemIdChangeCount = 0;
        this.ignoreMeasurementDateChangeCount = 0;
        this.ignoreSnapshotIdChangeCount = 0;
        this.datePickerConfig = {
            dateFormat: "d M Y",
            wrap: true,
            enableTime: false
        };
        // models
        this.systemIdFromRoute = 0;
        this.stringIdFromRoute = 0;
        this.query = new GetStringSnapshotsGroupedByTimestampQuery({
            timezoneOffset: moment().utcOffset(),
            systemId: 0,
            measurementDate: new Date()
        });
        this.apiRequest = null;
        this.apiRequestHeartbeatId = 0;
        // arrays
        this.systems = new Array();
        this.lastSnapshot = null;
        this.snapshots = new Array();
    }
    created() {
        this.systemIdFromRoute = parseInt(this.$route.params.systemId) || 0;
        this.stringIdFromRoute = parseInt(this.$route.params.stringId) || 0;
    }
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadInitialData();
        });
    }
    createEmptySystemModel() {
        const systemModel = new SystemAccessQueryModel();
        systemModel.init({});
        systemModel.displayName = this.selectPlaceholder;
        return systemModel;
    }
    getSystemIdFromQueryOrRoute() {
        if (this.systemIdFromRoute) {
            return this.systemIdFromRoute;
        }
        else if (queryStringHelper.hasParameter("systemId")) {
            const value = queryStringHelper.getParameter("systemId");
            if (value && parseInt(value)) {
                return parseInt(value);
            }
        }
        return null;
    }
    getMeasurementDateFromQueryString() {
        if (queryStringHelper.hasParameter("measurementDate")) {
            const parameter = queryStringHelper.getParameter("measurementDate");
            if (parameter) {
                return DateHelper.convertToDate(parameter);
            }
        }
        return null;
    }
    getSnapshotTimeFromQueryString() {
        if (queryStringHelper.hasParameter("snapshot")) {
            const parameter = queryStringHelper.getParameter("snapshot");
            if (parameter) {
                return DateHelper.convertToDate(parameter);
            }
        }
        return null;
    }
    getStringIdFromQueryStringOrRoute() {
        if (this.stringIdFromRoute) {
            return this.stringIdFromRoute;
        }
        else if (queryStringHelper.hasParameter("stringId")) {
            const value = queryStringHelper.getParameter("stringId");
            if (value && parseInt(value)) {
                return parseInt(value);
            }
        }
        return null;
    }
    /**
     * Load systems and initial data
     */
    loadInitialData() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.$emit("onIsBusy", true);
                const systemIdPreSelected = this.getSystemIdFromQueryOrRoute();
                const measurementDatePreSelected = this.getMeasurementDateFromQueryString();
                const snapshotTimePreSelected = this.getSnapshotTimeFromQueryString();
                const stringIdPreSelected = this.getStringIdFromQueryStringOrRoute();
                const query = new GetInitialSnapshotDataQuery({
                    systemId: systemIdPreSelected,
                    stringId: stringIdPreSelected,
                    measurementDate: measurementDatePreSelected,
                    specificSnapshotTime: snapshotTimePreSelected,
                    timezoneOffset: moment().utcOffset()
                });
                const response = yield snapshotsClient.getInitialData(query);
                var isDateFromQuery = !!measurementDatePreSelected;
                this.processInitialData(response, isDateFromQuery);
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.$emit("onIsBusy", false);
            }
        });
    }
    loadSystemData(systemId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.working)
                return;
            try {
                this.$emit("onIsBusy", true);
                this.working = true;
                const query = new GetSystemSnapshotDataQuery({
                    systemId: systemId,
                    timezoneOffset: moment().utcOffset()
                });
                const response = yield snapshotsClient.getSystemData(query);
                this.processSystemData(response);
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.$emit("onIsBusy", false);
                this.working = false;
            }
        });
    }
    loadDateData(systemId, measurementDate) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.working)
                return;
            try {
                this.$emit("onIsBusy", true);
                this.working = true;
                const query = new GetDateSnapshotDataQuery({
                    systemId: systemId,
                    stringId: ((_a = this.selectedString) === null || _a === void 0 ? void 0 : _a.componentId) || null,
                    measurementDate: DateHelper.convertToDate(measurementDate.toString()),
                    timezoneOffset: moment().utcOffset()
                });
                const response = yield snapshotsClient.getDateData(query);
                this.processDateData(response);
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.$emit("onIsBusy", false);
                this.working = false;
            }
        });
    }
    // Process methods
    processInitialData(data, isDateFromQuery) {
        var _a, _b, _c, _d, _e;
        // Set systems
        const emptySystem = this.createEmptySystemModel();
        this.systems = [emptySystem, ...(data.systems || [])];
        // Set system ID
        if (data.selectedSystemId) {
            this.setSystemId(data.selectedSystemId);
        }
        // Process snapshot data
        if (((_a = data.lastSnapshot) === null || _a === void 0 ? void 0 : _a.snapshot) || (data === null || data === void 0 ? void 0 : data.selectedSnapshot)) {
            this.lastSnapshot = (_b = data.lastSnapshot) === null || _b === void 0 ? void 0 : _b.snapshot;
            let snapshotDate = (_d = (_c = this.lastSnapshot) === null || _c === void 0 ? void 0 : _c.whenCreated) !== null && _d !== void 0 ? _d : (_e = data.selectedSnapshot) === null || _e === void 0 ? void 0 : _e.measurementTime;
            this.setMeasurementDate(snapshotDate);
            if (!isDateFromQuery) {
                const dateStamp = DateHelper.convertToFriendlyMomentTimeString(snapshotDate);
                Notifier.onOk(`Last snapshot was taken on ${dateStamp}`);
            }
        }
        else {
            var measurementDateFromQuery = this.getMeasurementDateFromQueryString();
            if (measurementDateFromQuery) {
                this.setMeasurementDate(measurementDateFromQuery);
            }
        }
        this.processSnapshotsList(data.availableSnapshots, data.selectedSnapshot);
        this.lastSnapshotLoaded = true;
        this.reactToQueryChanges = true;
        this.updateQueryString();
        // Notify parent
        this.notifyParent(data);
    }
    processSystemData(data) {
        var _a;
        if ((_a = data.lastSnapshot) === null || _a === void 0 ? void 0 : _a.snapshot) {
            this.lastSnapshot = data.lastSnapshot.snapshot;
            this.setMeasurementDate(data.lastSnapshot.snapshot.whenCreated);
            const dateStamp = DateHelper.convertToFriendlyMomentTimeString(data.lastSnapshot.snapshot.whenCreated);
            Notifier.onOk(`Last snapshot was taken on ${dateStamp}`);
        }
        this.processSnapshotsList(data.availableSnapshots, data.selectedSnapshot);
        this.updateQueryString();
        // Notify parent
        this.notifyParent(data);
    }
    processDateData(data) {
        this.processSnapshotsList(data.availableSnapshots, data.selectedSnapshot);
        // Notify parent
        this.notifyParent(data, false);
    }
    processSnapshotsList(availableSnapshots, selectedSnapshot) {
        this.snapshots = availableSnapshots || [];
        // Format snapshot times
        this.snapshots.forEach(snapshot => {
            snapshot.measurementTimeText = DateHelper.convertToFriendlyMomentTimeString(snapshot.measurementTime);
        });
        // Select snapshot
        if (selectedSnapshot) {
            this.setSnapshotId(selectedSnapshot.measurementTime);
        }
        else if (this.snapshots.length > 0) {
            const idx = this.selectLastSnapshot ? this.snapshots.length - 1 : 0;
            this.selectLastSnapshot = false;
            this.setSnapshotId(this.snapshots[idx].measurementTime);
        }
        if (this.snapshots.length === 0) {
            Notifier.onWarning("There are no snapshots available on this date.");
            this.$emit("onStringSnapshotNotFound");
        }
        this.updateQueryString();
    }
    notifyParent(data = null, notifysystemSelected = true) {
        if (notifysystemSelected) {
            const system = this.systems.find(s => s.systemId === this.query.systemId);
            this.$emit("onSystemSelectedEvent", this.query.systemId, data, this.query.measurementDate, system === null || system === void 0 ? void 0 : system.controllerKeepAlive);
        }
        if (this.snapshot) {
            this.$emit("onStringSnapshotSelectedEvent", this.snapshot, data);
        }
    }
    /**
     * Check API sync status - separate from snapshot loading
     */
    checkApiSyncStatus() {
        const query = new GetLatestStringSnapshotStatusQuery({
            systemId: this.systemId
        });
        snapshotClient
            .getLastStringSnapshotStatus(query)
            .then(response => {
            const lastSnapshot = response.snapshot || null;
            this.apiRequest = response.apiRequest || null;
            if (!this.apiRequest) {
                this.hasNewSnapshot = false;
            }
            this.endHeartbeatIfRequired();
            if (!lastSnapshot || !lastSnapshot.snapshotId)
                return;
            const latestTimestamp = DateHelper.convertToDate(lastSnapshot.whenCreated.toString());
            const previousTimestamp = this.lastSnapshot
                ? DateHelper.convertToDate(this.lastSnapshot.whenCreated.toString())
                : null;
            this.hasNewSnapshot = previousTimestamp == null || latestTimestamp > previousTimestamp;
            if (this.hasNewSnapshot) {
                this.endHeartbeat();
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    startHeartbeat() {
        this.endHeartbeat();
        this.apiRequestHeartbeatId = window.setInterval(() => this.checkApiSyncStatus(), 5000);
    }
    endHeartbeat() {
        try {
            window.clearInterval(this.apiRequestHeartbeatId);
        }
        catch (_a) {
        }
    }
    endHeartbeatIfRequired() {
        const shouldStop = this.apiRequest == null ||
            this.apiRequest.statusId == 1 ||
            this.apiRequest.statusId == 2 ||
            this.apiRequest.hasTimedOut;
        if (!shouldStop)
            return;
        this.endHeartbeat();
    }
    // Navigation methods
    previousDay() {
        this.query.measurementDate = DateHelper.addDay(this.query.measurementDate || new Date(), -1);
    }
    nextDay() {
        this.selectLastSnapshot = true;
        this.query.measurementDate = DateHelper.addDay(this.query.measurementDate || new Date(), 1);
    }
    nextSnapshot() {
        const snapshot = this.snapshot;
        if (this.snapshots.length && snapshot) {
            const idx = this.snapshots.indexOf(snapshot);
            if (idx > 0) {
                this.snapshotId = this.snapshots[idx - 1].measurementTime;
                return;
            }
        }
        this.nextDay();
    }
    previousSnapshot() {
        const snapshot = this.snapshot;
        if (this.snapshots.length && snapshot) {
            const idx = this.snapshots.indexOf(snapshot);
            if (idx >= 0 && idx < this.snapshots.length - 1) {
                this.snapshotId = this.snapshots[idx + 1].measurementTime;
                return;
            }
        }
        this.previousDay();
    }
    /**
     * Request controller data - separate action
     */
    requestControllerData() {
        if (!this.systemId || this.working)
            return;
        this.working = true;
        this.$emit("onIsBusy", true);
        systemCommunicationsClient
            .requestControllerData(new RequestControllerDataCommand({
            requestModel: new RequestControllerDataRequestModel({
                systemId: this.systemId
            })
        }))
            .then(response => {
            this.apiRequest = response.apiRequest || null;
            if (this.apiRequest) {
                this.startHeartbeat();
            }
            if (response.success) {
                Notifier.onOk("Measurement data has been successfully requested.");
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
            this.apiRequest = new ApiRequestModel();
            this.apiRequest.statusId = 2;
            this.apiRequest.whenCreated = new Date();
        })
            .finally(() => {
            this.$emit("onIsBusy", false);
            this.working = false;
        });
    }
    /**
     * View latest snapshot - clears filters and reloads
     */
    viewLatestSnapshot() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.apiRequest)
                return;
            this.working = true;
            try {
                yield apiRequestClient.markRequestAsRead(new MarkApiRequestAsReadCommand({
                    requestModel: this.apiRequest
                }));
                this.hasNewSnapshot = false;
                this.endHeartbeatIfRequired();
                // Clear filters
                this.setMeasurementDate(null);
                queryStringHelper.clearQueryString();
                // Reload system data
                this.working = false;
                yield this.loadSystemData(this.systemId);
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.working = false;
            }
        });
    }
    // Helper methods to set values without triggering watchers
    setSystemId(value) {
        this.ignoreSystemIdChangeCount++;
        this.query.systemId = value;
        // Use Vue.nextTick with a callback to ensure it executes after all updates
        this.$nextTick(() => {
            // Use setTimeout to ensure we're after ALL reactive updates
            setTimeout(() => {
                this.ignoreSystemIdChangeCount--;
            }, 100);
        });
    }
    setMeasurementDate(value) {
        this.ignoreMeasurementDateChangeCount++;
        this.query.measurementDate = value;
        this.$nextTick(() => {
            setTimeout(() => {
                this.ignoreMeasurementDateChangeCount--;
            }, 100);
        });
    }
    setSnapshotId(value) {
        this.ignoreSnapshotIdChangeCount++;
        this.snapshotId = value;
        this.$nextTick(() => {
            setTimeout(() => {
                this.ignoreSnapshotIdChangeCount--;
            }, 100);
        });
    }
    // Getters and setters
    get systemId() {
        return this.query.systemId;
    }
    get system() {
        return this.systems.filter(item => {
            return item.systemId == this.systemId;
        })[0];
    }
    set system(item) {
        if (!item || !item.systemId)
            return;
        // This setter is called by the multiselect - DON'T use setSystemId here
        // Let the watcher handle it
        this.query.systemId = item.systemId;
    }
    get snapshot() {
        console.log('get snapshot', this.snapshotId);
        return this.snapshots.filter(item => {
            return item.measurementTime.toString() == this.snapshotId.toString();
        })[0] || null;
    }
    set snapshot(item) {
        // This setter is called by the multiselect - DON'T use setSnapshotId here
        // Let the watcher handle it
        console.log('set snapshot', item);
        this.snapshotId = !item ? new Date() : item.measurementTime;
    }
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    get systemsLoaded() {
        return this.systems && this.systems.length ? true : false;
    }
    get isBusy() {
        return this.working || this.isParentBusy ? true : false;
    }
    get hasApiRequest() {
        return this.apiRequest && this.apiRequest.statusId != 1 ? true : false;
    }
    set hasApiRequest(value) {
        this.apiRequest = null;
    }
    get apiRequestCssClass() {
        if (!this.apiRequest)
            return "";
        if (this.apiRequest.statusId == 2)
            return "danger";
        if (this.apiRequest.statusId == 1)
            return "success";
        if (this.apiRequest.hasTimedOut)
            return "warning";
        return "primary";
    }
    get apiRequestTimestamp() {
        if (!this.apiRequest)
            return "";
        return DateHelper.convertToFriendlyMomentTimeString(this.apiRequest.whenCreated);
    }
    get apiRequestText() {
        if (!this.apiRequest)
            return "";
        if (this.apiRequest.statusId == 1)
            return "";
        if (this.apiRequest.statusId == 2)
            return "Requested snapshot failed, please try again.";
        if (this.apiRequest.hasTimedOut)
            return "Requested snapshot has not been received in expected timeframe, please try again.";
        return "Snapshot requested, waiting for new data.";
    }
    get requestControllerDataButtonText() {
        const defaultText = "Update";
        if (!this.apiRequest)
            return defaultText;
        if (this.apiRequest.statusId == 2)
            return defaultText;
        if (this.apiRequest.statusId == 1)
            return defaultText;
        if (this.apiRequest.hasTimedOut)
            return defaultText;
        return "Requested";
    }
    get enableRequestControllerDataButton() {
        if (!this.system || !this.system.controllerKeepAlive)
            return false;
        if (!this.apiRequest)
            return true;
        if (this.apiRequest.statusId == 2)
            return true;
        if (this.apiRequest.statusId == 1)
            return true;
        if (this.apiRequest.hasTimedOut)
            return true;
        return false;
    }
    // Watchers
    onSystemChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.ignoreSystemIdChangeCount > 0) {
                return;
            }
            //this.reactToQueryChanges = !this.systemIdFromRoute || this.systemId == this.systemIdFromRoute;
            if (this.systemIdFromRoute && this.systemId && this.systemId != this.systemIdFromRoute) {
                yield this.$router.push({
                    name: RouteNames.SnapshotForSystem,
                    params: { systemId: `${this.systemId}` }
                });
                return;
            }
            const resetFilters = this.parentLoaded &&
                this.systemId &&
                this.previousSystemId &&
                this.systemId != this.previousSystemId;
            this.previousSystemId = this.systemId;
            if (resetFilters) {
                this.setMeasurementDate(null);
                queryStringHelper.clearQueryString();
            }
            this.apiRequest = null;
            this.hasNewSnapshot = false;
            yield this.loadSystemData(this.systemId);
        });
    }
    onMeasurementDateChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.ignoreMeasurementDateChangeCount > 0) {
                return;
            }
            if (!this.lastSnapshotLoaded)
                return;
            yield this.loadDateData(this.systemId, this.query.measurementDate);
        });
    }
    onSnapshotIdChanged() {
        if (this.ignoreSnapshotIdChangeCount > 0) {
            return;
        }
        this.$emit("onStringSnapshotSelectedEvent", this.snapshot);
        this.updateQueryString();
    }
    onControllerDataRequestTimestampChanged() {
        this.requestControllerData();
    }
    updateQueryString() {
        if (!this.reactToQueryChanges)
            return;
        if (!this.lastSnapshotLoaded)
            return;
        const params = [];
        if (!this.systemIdFromRoute) {
            params.push({ value: this.systemId || null, parameterName: "systemId" });
        }
        const measurementDate = this.query.measurementDate
            ? DateHelper.convertToDate(this.query.measurementDate.toString()).toISOString()
            : null;
        const snapshot = this.snapshot
            ? DateHelper.convertToDate(this.snapshot.measurementTime.toString()).toISOString()
            : null;
        params.push({ value: measurementDate || null, parameterName: "measurementDate" });
        params.push({ value: snapshot || null, parameterName: "snapshot" });
        queryStringHelper.updateQueryStrings(params);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], SnapshotGraphFilterVue.prototype, "parentLoaded", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], SnapshotGraphFilterVue.prototype, "isParentBusy", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], SnapshotGraphFilterVue.prototype, "controllerDataRequestTimestamp", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], SnapshotGraphFilterVue.prototype, "selectedString", void 0);
__decorate([
    Watch("systemId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], SnapshotGraphFilterVue.prototype, "onSystemChanged", null);
__decorate([
    Watch("query.measurementDate"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
], SnapshotGraphFilterVue.prototype, "onMeasurementDateChanged", null);
__decorate([
    Watch("snapshotId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SnapshotGraphFilterVue.prototype, "onSnapshotIdChanged", null);
__decorate([
    Watch("controllerDataRequestTimestamp"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SnapshotGraphFilterVue.prototype, "onControllerDataRequestTimestampChanged", null);
SnapshotGraphFilterVue = __decorate([
    Component({
        name: "SnapshotGraphFilterVue",
        emits: ["onStringSnapshotSelectedEvent", "onSystemSelectedEvent", "onStringSnapshotNotFound", "onIsBusy"]
    })
], SnapshotGraphFilterVue);
export default SnapshotGraphFilterVue;
